import { useMutation, useQueryClient } from "@tanstack/react-query";
import BankMpProvider from "@/core/data-provider/data-mp/bank/bank-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { QUERY_KEY_BANK_CHARACTER } from "@/domains/bank/hooks/useBankCharacterQuery";

export function useBankTransferMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      transferAmount,
      accountNumber,
      atmId,
      filialId,
    }: {
      transferAmount: number;
      accountNumber: string;
      atmId: number | null;
      filialId: number | null;
    }) => {
      const response = await BankMpProvider.transfer({
        transferAmount,
        accountNumber,
        atmId,
        filialId,
      });

      if (response instanceof RpcMpProviderFailedResponse) {
        throw new Error(response.error?.message);
      }

      return response.data;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: [QUERY_KEY_BANK_CHARACTER] });
    },
  });
}
